import { cn } from "@/lib/utils";
import logoImage from "@/assets/munshi/logo.png";

interface MunshiLogoProps {
  className?: string;
  size?: number;
}

export function MunshiLogo({ className, size = 40 }: MunshiLogoProps) {
  return (
    <div 
      className={cn(
        "relative flex items-center justify-center",
        className
      )}
      style={{ width: size, height: size }}
    >
      <img 
        src={logoImage} 
        alt="Munshi Ji"
        className="w-full h-full object-contain"
      />
    </div>
  );
} 